export const PUBLIC_PORTFOLIO_ANNOUNCEMENT_TOOLTIP_NAME = 'portfolio:announcement-modal';
export const ACADEMY_DISCOVERING_TOOLTIP_NAME = 'academy:discovering-modal';
export const JOBS_DISCOVERING_TOOLTIP_NAME = 'jobs:discovering-modal';

export interface IAnnouncementFeature {
  key: string;
  tooltipName: string;
  component: string;
  onlyForAdmins?: boolean;
}

export const ANNOUNCEMENT_FEATURES: IAnnouncementFeature[] = [
  // Newest feature should come first
  {
    key: 'jobs',
    tooltipName: JOBS_DISCOVERING_TOOLTIP_NAME,
    component: 'JobsDiscoveringModal',
  },
  {
    key: 'seller-portfolio',
    tooltipName: PUBLIC_PORTFOLIO_ANNOUNCEMENT_TOOLTIP_NAME,
    component: 'PublicPortfolioAnnouncement',
  },
  {
    key: 'academy',
    tooltipName: ACADEMY_DISCOVERING_TOOLTIP_NAME,
    component: 'AcademyDiscoveringModal',
  },
];
